// extracted by mini-css-extract-plugin
export default {"projects-container":"projects_projects-container__-yyAy"};